import SideSheet from '..';
import { TargetSideSheetProps } from '../../../types';
import './TargetSideSheet.scss';

const TargetSideSheet = ({ onClose = () => {}, show, data }: TargetSideSheetProps) => {
  const close = () => {
    onClose();
  };

  //   border-radius: 20px;
  // background: #E4F7F3;

  return (
    <div>
      <SideSheet onClose={close} active={show} title="Target Details">
        <div className="target-details flex--4">
          <div className="target-details__hero">
            <h1>{data['amount']}</h1>
          </div>

          <div>Start Date</div>
          <div>Frequency</div>
          <div> End Date</div>
          <div className="details flex--2"></div>
        </div>
      </SideSheet>
    </div>
  );
};

export default TargetSideSheet;
